<template>
  <v-row no-gutters>
    <v-col cols="12">
      <v-stepper non-linear flat :value="activeStep.label">
        <v-stepper-header>
          <template v-for="(item, index) in stepsList">
            <v-stepper-step
              :class="prasymasStepClass"
              :step="item.label"
              :key="item.value"
              editable
              @click="gotoStep(item)"
            >
              {{ item.showText }}
            </v-stepper-step>
            <v-divider
              v-if="index < stepsList.length - 1"
              :key="`divider${item.value}`"
            ></v-divider>
          </template>
        </v-stepper-header>
      </v-stepper>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'ElPaslaugaStep',
  props: {
    step: String,
    steps: Array,
  },
  data() {
    return {
      stepsTab: null,
    }
  },
  computed: {
    stepsList() {
      return this.steps.map(item => {
        item.active = item.value == this.step
        item.showText = item.text.toUpperCase()

        return item
      })
    },
    activeStep() {
      return this.steps.find(item => item.value == this.step)
    },
    prasymasStepClass() {
      return this.stepsList.length > 3 ? 'prasymas-short-step' : ''
    },
  },
  methods: {
    gotoStep(item) {
      this.$emit('gotoStep', item.value)
    },
  },
}
</script>

<style lang="scss">
.prasymas-short-step {
  .v-stepper__label {
    max-width: 145px;
  }
}
</style>
